module.exports = __webpack_public_path__ + "static/media/treatment_var_hig.0c6016ec.png";